import { render, staticRenderFns } from "./BlockNum.vue?vue&type=template&id=10c7084f&scoped=true&"
import script from "./BlockNum.vue?vue&type=script&lang=js&"
export * from "./BlockNum.vue?vue&type=script&lang=js&"
import style0 from "./BlockNum.vue?vue&type=style&index=0&id=10c7084f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c7084f",
  null
  
)

export default component.exports